
export const Data = {
    nav: [
        { title: 'home' },
        { title: 'about' },
        { title: 'work' },
        { title: 'contact' }
    ],
    socials:[
        {name: 'github', link: 'https://github.com/reynaldos'},
        {name: 'instagram', link: 'https://www.instagram.com/reysanxez/'},
        {name: 'twitter', link: 'https://x.com/_innodev'},
        {name: 'linkedin', link: 'https://www.linkedin.com/in/reysanchez912'},
        {name: 'phone', link: 'tel:+1863-529-0492'},
    ],
    email: 'rey.sanchez.dev@gmail.com'


}